import _ from 'underscore';
import { isSelectedLanguagesOnlyTire2ForKeywordPlanner, getKeywordPlannerSupportedLanguagesByLocationIds } from '@bingads-webui-campaign-legacy/location-targets/util/constants';

export const isAllLocationsUnsupported = targetedLocationInfo => targetedLocationInfo.locations.length === 0 && targetedLocationInfo.numLocationsTargeted > 0;

export const getLanguagesSupportedByLocations = (locations, languages, useTireTwoMarkets = false) => {
  const locationSupportedLanguages =
    getKeywordPlannerSupportedLanguagesByLocationIds(locations, useTireTwoMarkets);

  return _.intersection(languages, locationSupportedLanguages);
};

export const onlyTire2LangaugesSelected = (locations, languages, crossCheckWithTargets = false) => {
  const languagesCanUse = crossCheckWithTargets ?
    getLanguagesSupportedByLocations(locations, languages, true) :
    languages;

  return !_.isEmpty(languagesCanUse) && isSelectedLanguagesOnlyTire2ForKeywordPlanner(languagesCanUse);
};
